<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm12 text-md-right>
        <v-btn class="text-14-security" to="/avisos/nuevo" flat>
          <img src="@/assets/ver-mas.png" class="pr-1" />
          Crear aviso
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 hidden-sm-and-up>
        <v-select
          :items="types"
          v-model="categorySelect"
          label="Categoría"
          outline
          @change="changeCategory(categorySelect)"
        ></v-select>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex sm2 hidden-xs-only>
        <v-btn
          v-for="(type, idx) in types"
          :key="idx"
          block
          flat
          class="btn-white-security text-14-security"
          :style="type == category ? 'background: #789c4a !important; border-color: #789c4a !important; color: white; font-weight: 700;': '' "
          @click="changeCategory(type)"
          :id="type"
        >{{ type }}</v-btn>
        <v-btn class="btn-white-security text-14-security mt-5" flat block to="/perfil/mis-avisos" :style="this.$route.name == 'my-products' ? 'background: #789c4a !important; border-color: #789c4a !important; color: white; font-weight: 700;': '' "> Mis Anuncios</v-btn>
        <v-btn class="btn-white-security text-14-security" :hidden="this.$route.name !== 'my-products'" flat block to="/avisos-clasificados"> Todos los anuncios</v-btn>
      </v-flex>
      <v-flex xs12 :class="{'sm10 pl-4': $vuetify.breakpoint.smAndUp}">
        <v-flex xs12 sm12 scroll-y id="scroll-target" style="max-height: 900px">
          <product-infinite :category="category" :url="url" :key="category"></product-infinite>
        </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ProductInfinite from "./ProductInfinite";
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      category: "todos",
      types: ["todos", "autos", "propiedades", "servicios", "varios"],
      categorySelect: "todos",
    };
  },
  props: {
    url: {
      type: String,
      required: true
    },
    filterCategory: {
      type: String,
      required: false
    }
  },
  components: {
    ProductInfinite
  },
  computed: {
    ...mapState("user", ["current_user"]),
    ...mapGetters("products", ["getTypes"]),
    ...mapGetters("products", ["getProducts"])
  },
  methods: {
    changeCategory(cat) {
      this.category = cat;
    }
  },
  mounted(){
    let param = this.$route.params.category
    if ( param && param.length)
      this.category = param
  }
};
</script>
